import executeQuery from "#lib/db"

export const getRatings = async ({ userID }: { userID: string }) => {
	const list = await executeQuery({
		query: `select * from ratings where userID=${userID}`,
	})

	return list
}
